module.exports = __webpack_public_path__ + "assets/img/6.33edda17.png";